import type { Locale } from '@lemonade-hq/lemonation';
import type { DocumentTypes } from 'contentlayer/generated';
import { useMDXComponent } from 'next-contentlayer2/hooks';
import { useRouter } from 'next/router';

export interface UseContentProps {
  locale: Locale;
  content: DocumentTypes[];
}

export const useContent = ({ locale, content }: UseContentProps) => {
  const router = useRouter();
  const filteredContent = content.find(({ slugAsParams }) => slugAsParams === locale);

  if (filteredContent?.body.code == null) router.push('/404');
  const Component = useMDXComponent(filteredContent?.body.code ?? '');

  return Component;
};

export const useContent2 = ({ content }: { content: DocumentTypes }) => {
  const router = useRouter();

  if (content?.body.code == null) router.push('/404');
  const Component = useMDXComponent(content?.body.code ?? '');

  return Component;
};
